<template>
  <div class="factoring-container">
    <div class="project-table">
      <avue-crud
        :option="option"
        :data="tableData"
        ref="crud"
        :page.sync="page"
        v-model="form"
        :table-loading="loading"
        @on-load="queryTableData"
        @row-click="handleRowClick"
      >
      </avue-crud>
    </div>
  </div>
</template>

<script>
import { getAuditedListByCustId, deleteFactoring } from "@/api/factoring/factoring";

export default {
  name: "historyItems",
  data() {
    return {
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      form: {},
      query: {},
      tableData: [],
      option: {
        // excelBtn: true,
        menuType: "button",
        menuWidth: 380,
        menuAlign: "center",
        align: "center",
        card: false,
        tip: false,
        lazy: false,
        tree: false,
        filterable: false,
        editBtn: false,
        cellBtn: false,
        delBtn: false,
        addBtn: false,
        selection: false,
        searchBtn: false,
        columnBtn: false,
        refreshBtn: false,
        labelWidth: 200,
        index: true,
        indexLabel: "序号",
        dialogClickModal: false,
        menu: false,
        column: [
          // {
          //   label: "合同编号",
          //   prop: "number",

          //   display: true,
          // },
          {
            label: "项目名称",
            prop: "projectName",
            overHidden: true,
            display: true,
          },
          // {
          //   label: "合同名称",
          //   prop: "contractName",
          //   overHidden: true,
          //   display: true,
          // },
          // {
          //   label: "业务类型",
          //   prop: "projectTypeStr",
          // },
          {
            label: "保理额度",
            prop: "factoringCredit",
            formatter: (row, value, label, column) => {
              return `${this.getMoney(value)}元`;
            },
          },
          {
            label: "业务主办",
            prop: "managerUserName",
          },
          {
            label: "业务协办",
            prop: "assistUserName",
          },
          {
            label: "所属部门",
            prop: "managerDeptName",
          },
          // {
          //   label: "项目状态",
          //   prop: "auditStatusStr",
          // },
          {
            label: "创建日期",
            prop: "createTime",
          },
        ],
      },
      loading: false,
    };
  },
  props: {},
  watch: {},

  components: {},

  methods: {
    //点击行跳转详情
    handleRowClick(row, event, column) {
      this.$router.push({
        path: `/factoring/projectSurvey/surveyDetail/${row.reportId}`,
      });
    },
    async queryTableData() {
      this.loading = true;
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        custId: this.$route.params.id,
      };
      let res = await getAuditedListByCustId(params);
      if (res.data.code == 200) {
        let data = res.data.data;

        this.tableData = data;
        this.page.total = res.data.data.length;
        this.loading = false;
      } else {
        this.$message.error(res.data.msg);
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.factoring-container {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
}
.none-border {
  border: 0;
  background-color: transparent !important;
}
/deep/ .avue-crud__menu {
  display: none;
}
</style>
<style lang="scss">
.factoring-container {
  .el-table__fixed,
  .el-table__fixed-right {
    height: calc(100% - 10px) !important;
  }
  .el-table__fixed-footer-wrapper {
    display: none !important;
  }
}
</style>